module.exports = __webpack_public_path__ + "img/img82.4c216fb0.png";